export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/book.435d5956.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};